<!-- 搜索功能页 -->
<template>
  <div class="page-content">
    <c-header pageName="移位"></c-header>
    <div class="search-content flex-wrap">
      <div class="content-item flex">
        <section
          class="flex"
          v-if="ownWarehouseList.length>0"
          @click="handleSelectWarehouse"
        >{{ selectWarehouse.warehouseName ? selectWarehouse.warehouseName : "请选择仓库" }}
        </section>
        <section class="flex" v-else>{{ selectWarehouse.warehouseName }}</section>
        <van-icon name="arrow-down" style="margin-right: 10px"/>
      </div>
      <div class="content-item flex">
        <section class="search-tool" v-if="!isScanned">
          <van-field v-model="slCode" autofocus clearable @blur="onScanComplete" @keydown.enter="onScanComplete"/>
          <span>扫描库位</span>
        </section>
        <section class="search-tool" v-else>
          <van-field v-model="barCode" autofocus clearable/>
          <span @click="onSearch">扫描国际条码</span>
        </section>
      </div>
      <div class="header flex-wrap mt-5" v-if="slCode">
        <section>库位 : {{ slCode }}</section>
      </div>
    </div>
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    :offset="100"
    >
      <div class="picking-item flex" v-for="(stockInfo,index) in stockInfos" :key="index">
        <div class="item-content" >
          <section>板号 : {{ stockInfo.bandSn }}</section>
          <section>商品名称 : {{ stockInfo.productName }}</section>
          <section>国际条码 : {{ stockInfo.barCode }}</section>
          <section>库存 : {{ stockInfo.stockDataOne.qty }}</section>
          <section>批次 : {{ stockInfo.batSn }}</section>
          <section>规格 : {{ stockInfo.specVal }}</section>
          <section>效期 : {{ stockInfo.productDate|dateSub }} ~ {{ stockInfo.invalidDate|dateSub }}</section>
          <section>商品状态 :&nbsp;
            <span :style="stockInfo.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">
              {{ stockInfo.defectFlag ? "不良品" : "良品" }}
            </span>
          </section>
          <section>库存状态 :&nbsp;
            <div v-for="status in StockStatus()" :key="status.value">
              <span v-if="status.value === stockInfo.stockStatus" :style="`color: ${status.color}`"> {{status.label }}</span>
            </div>
          </section>
          <section>库区 : {{ stockInfo.szCode }}</section>
          <section>库位 : {{ stockInfo.slCode }}</section>
        </div>
        <div class="item-icon">
          <i class="iconfont xiangyou" @click="goStockDetail(stockInfo)"></i>
        </div>
      </div>
    </van-list>
<!--    <div class="search-result flex" v-show="showResult">-->
<!--      <div class="storageLocation flex-wrap">-->
<!--        -->
<!--      </div>-->
<!--    </div>-->
    <van-picker
      show-toolbar
      v-show="showWarehousePicker"
      :columns="warehousePicker"
      @confirm="onWarehouseConfirm"
      @cancel="showWarehousePicker = false"
    />
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import StorageUtil from "../util/storage.js";
import {StockStatus} from "../common/constant";
import DataFormat from "../util/dataFormat";
import Utils from "../util/utils";

export default {
  data() {
    return {
      loading: false,
      finished: true,
      slCode: "", // 库位
      barCode: "", //条形码
      ownWarehouseList: [], // 用户绑定的仓库
      selectWarehouse: {}, // 选中的仓库
      warehousePicker: [],
      showWarehousePicker: false,
      showResult: false, // 显示搜索结果
      stockInfos: [],
      isScanned: false,
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
    this.member = StorageUtil.getLocalStorage("member");
    this.getMemberWarehouseList();
  },
  methods: {
    onScanComplete() {
      // 输入完成后，标记为已扫描，v-if 就会隐藏区域
      if (this.slCode.trim()) {
        this.isScanned = true;
      }
    },
    StockStatus() {
      return StockStatus
    },
    goStockDetail(data) {
      this.$router.push({ path: "/stockMoveDetail", query: { id: data.id, wid: data.warehouseId } });
    },
    // 查询用户绑定的仓库
    getMemberWarehouseList() {
      this.$post(this.URL.getWarehouseList, {
        ids: this.member.ownWarehouseIds
      }).then(res => {
        if (res.success) {
          this.ownWarehouseList = res.data;
          this.warehousePicker = this.ownWarehouseList.map(item => {
            return item.warehouseName;
          });
          if (this.ownWarehouseList.length === 1) {
            this.selectWarehouse = this.ownWarehouseList[0];
          }
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 点击弹出选中框
    handleSelectWarehouse() {
      this.showWarehousePicker = true;
    },
    // 仓库选择
    onWarehouseConfirm(value, index) {
      this.selectWarehouse = this.ownWarehouseList[index];
      this.showWarehousePicker = false;
    },

    // 搜索
    onSearch() {
      let requestUrl = this.URL.findStock;
      let param = {
        warehouseId: this.selectWarehouse.id
      };
      param.barCode = this.barCode;
      param.slCode = this.slCode;

      this.$post(requestUrl, param).then(res => {
        if (res.success) {
          this.showResult = true;
          this.stockInfos = res.data;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.nav-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  background-color: #dc6350;
  padding: 0 3rem;
  align-items: center;
  justify-content: center;

  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }

  .activity {
    background-color: white;
    color: #dc6350;
  }

  section:first-child {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
  }

  section:last-child {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }
}

.search-content {
  padding: 1rem;
  font-size: 0.9rem;
  color: #444;

  .content-item {
    height: 2.5rem;
    align-items: center;
    border: 1px solid #f0f0f0;
    border-radius: 0.5rem;
  }

  .content-item:first-child {
    margin: 1rem 0 1.5rem 0;
    padding-left: 1rem;
  }

  .search-tool {
    display: flex;
    width: 100%;
    height: 2.5rem;
    align-items: center;
    border-radius: 0.5rem;
    padding-left: 1rem;
    margin: 0.3rem 0;

    .van-cell {
      display: inline-flex;
      align-items: center;
      height: 2.2rem;
      padding: 0;
    }

    .van-cell:not(:last-child)::after {
      border-bottom: none;
    }

    span {
      display: inline-flex;
      height: 2.5rem;
      align-items: center;
      justify-content: center;
      width: 8rem;
      border-left: 1px solid #f0f0f0;
    }
  }
}

.search-result {
  padding: 1rem;
  font-size: 0.85rem;
  color: #444;

  section {
    display: flex;
    width: 100%;
    height: 1.8rem;
    align-items: center;
    padding: 0 0.5rem;
  }

  .header {
    border: 1px solid #dc6350;
    border-radius: 0.5rem;
  }

  .order-item {
    font-size: 0.8rem;
    border-bottom: 1px dashed #f0f0f0;
    padding: 0.5rem 0;

    section {
      height: 1.5rem;
    }
  }

  .goods-item {
    border-bottom: 1px dashed #f0f0f0;
    font-size: 0.8rem;

    .right {
      display: inline-flex;
      width: 90%;
      flex-wrap: wrap;
    }

    .left {
      display: inline-flex;
      width: 10%;
      align-items: center;
      justify-content: center;

      i {
        font-size: 1.3rem;
        color: #dc6350;
      }
    }
  }

  .tools {
    height: 1.8rem;
    justify-content: flex-end;

    span {
      display: inline-flex;
      width: 4rem;
      height: 1.8rem;
      background-color: #dc6350;
      color: #fff;
      align-items: center;
      justify-content: center;
      border-radius: 0.3rem;
    }
  }

  .ban {
    font-size: 0.8rem;
  }
}
.van-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  font-size: 0.85rem;
  padding: 0 0.8rem 0.5rem 0.8rem;
  color: #444;
  .picking-item {
    padding: 0 0 0.5rem 0;
    border-bottom: 1px dashed #eee;
    .item-content {
      display: inline-flex;
      width: 90%;
      flex-wrap: wrap;
      section {
        display: flex;
        width: 100%;
        line-height: 1.2rem;
        label {
          display: inline-flex;
        }
        label:first-child {
          width: 5rem;
        }
      }
    }
    .item-icon {
      display: inline-flex;
      width: 10%;
      align-items: center;
      justify-content: flex-end;
      i {
        font-size: 1.5rem;
        color: #dc6350;
      }
    }
  }
  >>> .van-list__loading {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  >>> .van-list__finished-text {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/StockMove.vue